

<div id="map" class="" style="top: 0;bottom: 0; right: 0;left: 0; position:fixed;">
    
    <div id="popup"></div>
    
    <div class="position-absolute" data-bs-html="true" id="map_tooltips">
        
    </div>
    
    <div class="position-absolute" data-bs-html="true" id="map_tooltip">
        
    </div>
    
</div>

<img src="../../../assets/Img/layer-icon.png" title="تغییر نوع نقشه" (click)="changeTail()" 

    class="bg-third p-2 circel-2 my-1 text-center pointer text-white icon-Img  r-0 index position-absolute">